import { of } from "rxjs";
import { selectActiveTutorialConfig } from "../../../selectors/selectTutorial";
import { actionTutorialSelect } from "../actionTutorial";
export var pathTutorialUpdate = function (action, state$, deps) {
    var state = state$.value;
    var tutorialConfig = selectActiveTutorialConfig(state);
    return of(actionTutorialSelect(tutorialConfig.nextStep));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/path/pathTutorialUpdate.ts
// module id = 259
// module chunks = 3